import { LocaleType } from '..'
import zh from './zh-CN.json'
import en from './en.json'

const message = {
  [LocaleType.zhCN]: zh,
  [LocaleType.en]: en,
}

const fallbackLocale = LocaleType.zhCN
export const fallbackMsg = {
  [LocaleType.zhCN]: '系统遇到错误，请重试',
  [LocaleType.en]: 'System Error Encountered, Please retry.',
}

export interface IApiTProps {
  code?: number
  data?: any
  extend?: Record<string, string>
}

export const apiT = (currentLocal: LocaleType, data?: IApiTProps) => {
  try {
    if (!data) {
      return { message: fallbackMsg[currentLocal], matchOrNot: false }
    }

    const { code, extend } = data || {}
    if (!code) {
      throw new Error('code is required')
    }
    const key = code.toString()
    const locale = currentLocal

    // @ts-ignore
    const msg: string = message[locale][key] || message[fallbackLocale][key] || fallbackMsg[locale]

    // 匹配所有 {placeholder} 中的内容并替换为 extend 中的内容
    const reg = /\{([^}]+)\}/g
    return {
      message: msg.replace(reg, (word, key) => {
        return extend?.[key] || word
      }),
      matchOrNot: true,
    }
  } catch (error) {
    return { message: fallbackMsg[currentLocal], matchOrNot: false }
  }
}
